/* Bootstrap imports */
import Bootstrap from 'bootstrap-sass/assets/javascripts/bootstrap';

/* Utilities imports */
import { ScrollTo } from "./Utilities/scrollTo";
import ResizeFunction from './Utilities/Resize';
import Scroll from './Utilities/Scroll';
import {Fancybox} from './Utilities/Fancybox';

/* Theme imports */
/* eg. import tooltip from './Theme/Tooltip'; */
import {Quotes} from './Theme/Quotes';
import {Slick} from './Theme/Slick';

/* Renders */
new ScrollTo();
new ResizeFunction();
new Fancybox();
new Scroll();
new Quotes();
new Slick();



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Index.js